import { getGraphqlClient } from "@/api/graphql/client.ts";
import { NOTIFICATIONS_PER_PAGE } from "@/api/graphql/notifications/constants.ts";
import { mapNotificationsPageFromGraphQLForUser } from "@/api/graphql/notifications/mappers.ts";
import type {
  GetNotificationsRequest,
  NotificationsPageBO,
} from "@/api/graphql/notifications/types.ts";
import { createEmptyNotificationsPage } from "@/api/graphql/notifications/types.ts";
import { GetNotificationsByUserQuery } from "@/api/graphql/notifications/user/queries.ts";
import type { GetNotificationsByUserQueryQuery } from "@/api/graphql/types/graphql.ts";

export const getNotificationsByUser = async ({
  filters,
  paging,
  sorts,
}: GetNotificationsRequest): Promise<NotificationsPageBO> => {
  const page = paging?.page || 1;
  const size = paging?.size || NOTIFICATIONS_PER_PAGE;

  const response =
    await getGraphqlClient().request<GetNotificationsByUserQueryQuery>(
      GetNotificationsByUserQuery,
      {
        request: {
          filters,
          paging: {
            page,
            size,
          },
          sorts,
        },
      },
    );

  return (
    mapNotificationsPageFromGraphQLForUser(
      response.NotificationsMsSearchNotifications,
    ) ?? {
      ...createEmptyNotificationsPage(page, size),
    }
  );
};
